import {Vue, Component, Prop} from 'vue-property-decorator';
import { taxonomyAPI } from '@/providers/apis/taxonomy/taxonomy';
import { sortByProperty } from '@/utils/utils';
import { competencyAPI } from '@/providers/apis/competency/competency';
import GoogleMaterialIcon from '@/components/icons/google-material-icon/google-material-icon';

@Component({
    name: 'gdot-add-mapping-popup',
    components: {'material-icon': GoogleMaterialIcon },
})

export default class GdotMappingPopup extends Vue {

    public categories: any = [];

    public  subjects: any = [];

    public  originalSubject: any;

    public universalOriginalSubjects: any;

    public selectedCategory: any = {};

    public activeFramework: any = null;

    public frameworkList: any;

    public selectedItem: any = null;

    public  universalSubjects: any = [];

    public selectedUniversalItem: any = null;

    public isConfirmation: boolean = false;

    public isMappingMsg = '';


    // ------------------------------------------------------------------
    // Properties

    @Prop()
    private isCompetency: any;

    @Prop()
    private subject: any;

    public mounted() {
        this.getUniversalSubjects();
        if (this.isCompetency) {
          this.onSelectSubject(this.subject);
        } else {
          taxonomyAPI.fetchTaxonomyClassifications().then((classifications: any) => {
            this.categories = classifications;
            let defaultCategory: any;
            if (classifications) {
            const activeCategory = classifications.find((item: any) => item.is_default);
            defaultCategory = classifications.length ? (activeCategory ? activeCategory : classifications[0]) : '';
            }
            this.selectedCategory = classifications ?
            classifications.find((category: any) => category.id === defaultCategory.id) : null;
            this.fetchSubject(defaultCategory);
          });
        }
        this.$bvModal.show('add-mapping');
    }
    public fetchSubject(defaultCategory: any) {
        taxonomyAPI.fetchTaxonomySubjects(defaultCategory.id).then((subject) => {
          sortByProperty(subject, 'sequenceId', 'ASC');
          subject.map((item: any) => {
            item.checked = false;
          });
          this.subjects = subject;
          this.originalSubject = subject;
        });
    }
    public onSelectSubject(content: any) {
        this.selectedItem = content;
        this.subjects.map((subject: any) => {
          if (subject.title === content.title) {
            subject.checked = true;
          } else {
            subject.checked = false;
          }
        });
        if (!content.frameworkId && !this.isCompetency) {
          this.fetchFrameworkList(content);
        }
    }
    public onEditSubject() {
        this.selectedItem = null;
    }
    public isEnableUniversalContainer() {
        const isCheck = this.subjects.find((subject: any) => subject.checked);
        return !this.isCompetency ? isCheck ? true : false : this.selectedItem ? true : false;
      }
      public onEditUniversalSubject() {
        this.selectedUniversalItem = null;
      }
      public getUniversalSubjects(searchTerm= '') {
        competencyAPI.getUniversalSubjectList(searchTerm).then((data) => {
          data.subjects.map((item: any) => {
            item.checked = false;
          });
          this.universalSubjects = data.subjects;
          this.universalOriginalSubjects = data.subjects;
        });
      }
      public onSelectUniversalSubject(content: any) {
        this.selectedUniversalItem = content;
        this.universalSubjects.map((subject: any) => {
          if (subject.universal_subject_name === content.universal_subject_name) {
            subject.checked = true;
          } else {
            subject.checked = false;
          }
        });
        // this.selectedSubject = null;
      }
      public hideConfirmation() {
        this.hideMappingModal();
        this.$bvModal.hide('confirmation-popup');
        this.isConfirmation = false;
        this.$emit('closePopup', true);
      }


    private hideMappingModal() {
        this.selectedItem = null;
        this.selectedUniversalItem = null;
        if (!this.isCompetency) {
          this.subjects = this.originalSubject;
          this.universalSubjects = this.universalOriginalSubjects;
          this.$bvModal.hide('add-mapping');
          this.universalSubjects.map((subject: any) => {
            subject.checked = false;
          });
          this.subjects.map((subject: any) => {
            subject.checked = false;
          });
        }
        this.$emit('closePopup', true);
    }
    private onSave() {
        const params = {
          universal_subject_name: this.selectedUniversalItem.universal_subject_name,
          universal_subject_code: this.selectedUniversalItem.universal_subject_code,
          target_subject_name: this.selectedItem && this.selectedItem.title ? this.selectedItem.title : null,
          target_subject_code: this.selectedItem && this.selectedItem.code ? this.selectedItem.code : null,
          target_framework_code: !this.isCompetency ? this.activeFramework.code : this.selectedItem.frameworkId,
        };
        competencyAPI.createUniversalSubject(params).then((content) => {
          if (content.status === 400) {
            this.isMappingMsg = content.data.message;
          }
          if (content.status === 201) {
            this.$bvModal.show('confirmation-popup');
            this.isConfirmation = true;
          }
        });
    }
    private onSelectCategory(category: any) {
        this.selectedCategory = category;
        this.fetchSubject(category);
    }
    private onChangeFW(framework: any) {
        this.activeFramework = framework;
    }
    private fetchFrameworkList(subject: any) {
        taxonomyAPI.fetchFrameworks(subject.code).then((framework: any) => {
        this.frameworkList = framework;
        this.activeFramework = framework[0];
        });
    }
    private onSearch(searchTerms: string) {
        if (searchTerms === '') {
            this.subjects = this.originalSubject;
        } else {
            this.subjects = this.subjects.filter((subject: any) => {
            return subject.title === searchTerms;
            });
        }
    }
      private onUniversalSearch(searchUniversalTerm: string) {
        if (searchUniversalTerm === '') {
          this.universalSubjects = this.universalOriginalSubjects;
        } else {
          this.universalSubjects = this.universalSubjects.filter((subject: any) => {
            return subject.universal_subject_name === searchUniversalTerm;
          });
        }
      }
      private isEnableSubmit() {
        return this.selectedItem && this.selectedUniversalItem;
      }
}
